import { gallowsPublishAtom, tourPublishAtom } from "./atoms";

export const publishGroups = {
  featureNodes: {
    models: ["featurenodes", "abouts", "resources", "tags", "mediaitems"],
    singleItems: ["welcomepopup"],
    atom: tourPublishAtom,
  },
  gallows: {
    models: ["people"],
    singleItems: ["screensaver"],
    atom: gallowsPublishAtom,
  },
};
